import { generateAutomationName } from "../../../../helpers/generateAutomationName";

export const activationItemTestKeys = {
    item: generateAutomationName("home", ["header", "activation", "dropdown", "item", "wrapper"]),
    sharedByIcon: generateAutomationName("home", ["header", "activation", "dropdown", "item", "sharedBy"]),
    selectedItemIcon: generateAutomationName("home", ["header", "activation", "dropdown", "item", "checkMark"]),
    defaultItemIcon: generateAutomationName("home", ["header", "activation", "dropdown", "item", "star"]),
};
